import { takeEvery, call, put } from 'redux-saga/effects';
import { apiGet } from '../core/dapi';
import { getLocationConsentFormsUrl } from '../core/dapi/locationConsentForms';
import { ajaxPending, ajaxSuccess } from '../actions/runtime';
import { locationConsentFormsReceived, locationConsentFormsError } from '../ducks/paperwork';
import { analyticsTrackEvent } from '../core/analytics';
import { PAPERWORK_ERROR_LOADING_LOCATION_CONSENT_FORMS } from '../core/analytics/events';

export class LocationConsentFormSagas {
  static FETCH_CONSENT_FORMS = 'SAGA/FETCH_CONSENT_FORMS';
}

function* fetchConsentForms({ locationId }) {
  yield put(ajaxPending(LocationConsentFormSagas.FETCH_CONSENT_FORMS));

  try {
    const response = yield call(apiGet, getLocationConsentFormsUrl(locationId));
    yield put(locationConsentFormsReceived(response.results));
    yield put(ajaxSuccess(LocationConsentFormSagas.FETCH_CONSENT_FORMS)(response.results));
  } catch (e) {
    yield put(locationConsentFormsError(e));
    analyticsTrackEvent(PAPERWORK_ERROR_LOADING_LOCATION_CONSENT_FORMS, {
      locationId,
    });
  }
}

export default function*() {
  yield takeEvery(LocationConsentFormSagas.FETCH_CONSENT_FORMS, fetchConsentForms);
}
